import type { MetaFunction } from 'react-router';
import { getCanonicalURL } from '@cx-web/utils/getCanonicalURL';

import { type loader } from './loader';

export const meta: MetaFunction<never, { [routeId: string]: typeof loader }> = ({ location, matches }) => {
  const data = matches.find(match => /horse-racing\/premium-market-movers$/.test(match.id))?.data;

  return [
    { title: `Premium Market Movers | Horse Racing | Oddschecker+` },
    {
      name: 'description',
      content:
        'Browse and bet daily via our premium market movers tool. Track market movers in real-time, follow the money, and use historical data to understand why.',
    },
    { tagName: 'link', rel: 'canonical', href: getCanonicalURL(data?.url.toString(), location.pathname) },
  ];
};
